export default "__VITE_ASSET__5tP$Zgnr__"